export enum PipelineGrowthDigestFrequencyEnum {
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY'
}

export enum PipelineGrowthDigestEmailContentEnum {
    EXPORTS = 'EXPORTS',
    ENRICHMENT = 'ENRICHMENT',
    SESSIONS = 'SESSIONS',
    SEARCHES = 'SEARCHES',
    VISITOR_INTEL = 'VISITOR_INTEL',
    INTENT = 'INTENT',
    ICP = 'ICP',
    NEWS = 'NEWS',
    ROD = 'ROD'
}
